import { createContext, useContext } from 'react';
import { businessType, type BusinessType, type HomeScreen, type ModuleKey } from '@makila/pos-core';

export interface BusinessInfo { type: string; modules: ModuleKey[]; home: HomeScreen; overrides: Record<string, boolean>; onboarded: boolean }

export interface BusinessCtx {
  info: BusinessInfo | null;
  /** Sem perfil carregado (sem rede), tudo à vista — como antes dos módulos. */
  has: (m: ModuleKey) => boolean;
  type: BusinessType;
  reload: () => Promise<void>;
}

export const Business = createContext<BusinessCtx>({ info: null, has: () => true, type: businessType('retail'), reload: async () => {} });
export const useBusiness = () => useContext(Business);

export function makeCtx(info: BusinessInfo | null, reload: () => Promise<void>): BusinessCtx {
  return { info, has: (m) => !info || info.modules.includes(m), type: businessType(info?.type ?? 'retail'), reload };
}
